import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/hooks/useAuth';
import PageLoader from '../components/loaders/PageLoader';
import { getUserInfo } from '../utils/getUserInfo'; 

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedGroups?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedGroups }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <PageLoader message="Loading" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (allowedGroups && allowedGroups.length > 0) {
    const user = getUserInfo();
    const userGroups = user?.groups || [];

    const hasAccess = userGroups.some(group => allowedGroups.includes(group));
    if (!hasAccess) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
